module.exports = __webpack_public_path__ + "static/media/Perf-Plus_White_login.257a2074.png";